export const locale = {
    lang: 'es',
    data: {
        'NAV': {
            'APPLICATIONS': 'Aplicaciones',
            'PORTFOLIO': {
                'TITULO': 'Portfolio'
            },
            'DASHBOARD': {
                'TITULO': 'Dashboard General'
            },
            'DOCUMENTOS': {
                'TITULO': 'Documentos'
            },
            'TICKETS': {
                'TITULO': 'Tickets'
            },
            'GESTION': 'Gestión',
            'ACTIVOS': {
                'TITULO': 'Activos'
            },
            'CLIENTES': {
                'TITULO': 'Clientes'
            },
            'USUARIOS': {
                'TITULO': 'Usuarios'
            },
            'SOCIEDADES': {
              'TITULO': 'Sociedades'
            }
        },
        'PANEL': {
            'TITULO': 'Activos',
            'BUSCAR': 'Búsqueda',
            'DETALLE': {
                'DASHBOARD': 'Dashboard',
                'DOCUMENTOS': 'Docs',
                '3DVIEWER': 'Visor 3D',
                'REVIEW': 'Tickets'
            }
        },
        'DASHBOARD': {
            'TITULO': 'Project Dashboard',
            'WIDGET1': {
                'TITULO': 'Documentos / Tickets',
                'DOCS': {
                    'TITULO': 'Últimos documentos',
                    'BOTON': 'Gestor Documental'
                },
                'TICKETS': {
                    'TITULO': 'Tickets recientes',
                    'BOTON': 'Gestor de Incidencias'
                },
                'ESTADO': 'Estado tickets'
            },
            'WIDGET2': {
                'TITULO': 'Localización'
            },
            'WIDGET3': {
                'TITULO': 'Dashboards PowerBI'
            },
            'WIDGET4': {
                'TITULO': '3D viewer'
            },
            'STATS': {
                'USO': 'Uso',
                'TIPOLOGIA': 'Tipología',
                'PROPIETARIO': 'Propietario',
                'NODESC': 'Sin descripción.',
                'REPORTING': 'Planos reporting',
                'BUILT': 'Doc. as built',
            }
        },
        'ACTIVOS': {
            'TABLA': {
                'CODIGO': 'Código',
                'NOMBRE': 'Nombre',
                'LOCALIZACION': 'Localización',
                'ESTADO': 'Estado',
                'TIPOLOGIA': 'Tipología'
            },
            'LISTADO': {
                'TITULO': 'Gestión de Activos',
                'BTN-CARGA': 'Cargar activos',
                'ADDACTIVO': 'Añadir Activo',
                'ADDKPI': 'Añadir KPI',
                'ADDPOWERBI': 'Añadir PowerBI'
            },
            'DETALLE': {
                'TITULO': 'Detalle de Activo',
                'CODIGO': 'Código',
                'NOMBRE': 'Nombre',
                'CIUDAD': 'Ciudad',
                'DIRECCION': 'Dirección',
                'ENLACE': 'Enlace 3D Viewer',
                'SECTOR': 'Sector',
                'ESTADO': 'Estado',
                'TIPOLOGIA': 'Tipología',
                'LATITUD': 'Latitud',
                'LONGITUD': 'Longitud',
                'SOCIEDAD': 'Sociedad propietaria',
                'DESCRIPCION': 'Descripción',
            },
            'EDITAR': {
                'EDITAR_TITULO': 'Editar Activo',
                'CREAR_TITULO': 'Nuevo Activo',
                'CODIGO': 'Código',
                'NOMBRE': 'Nombre',
                'CIUDAD': 'Ciudad',
                'DIRECCION': 'Dirección',
                'ENLACE': 'Enlace 3D Viewer',
                'SECTOR': 'Sector',
                'ESTADO': 'Estado',
                'TIPOLOGIA': 'Tipología',
                'LATITUD': 'Latitud',
                'LONGITUD': 'Longitud',
                'CLIENTE': 'Cliente',
                'GUARDAR': 'GUARDAR',
                'FOTO': 'EDITAR FOTO',
                'CANCELAR': 'CANCELAR',
                'SOCIEDAD': 'Sociedad propietaria',
                'DESCRIPCION': 'Descripción',
            },
            'MENSAJES': {
                'TITULOBORRAR': 'Borrar Activo',
                'FOTOGRANDE': 'El fichero supera el tamaño máximo de 500Kb',
                'MENSAJEBORRAR': '¿Está seguro de borrar el activo seleccionado?',
                'SINACTIVOS': 'No hemos obtenido datos de ningún activo',
                'ACTIVOBORRADO': 'El activo ha sido eliminado correctamente',
                'ACTIVONOBORRADO': 'No hemos podido eliminar el activo. Por favor, inténtelo de nuevo más adelante',
                'ACTIVONOOBTENIDO': 'No hemos podido obtener el activo. Por favor, inténtelo de nuevo más adelante',
                'ACTIVOCREADO': 'El activo ha sido creado correctamente',
                'ACTIVONOCREADO': 'No hemos podido crear el activo. Por favor, inténtelo de nuevo más adelante',
                'ACTIVOEDITADO': 'El activo ha sido editado correctamente',
                'ACTIVONOEDITADO': 'No hemos podido editar el activo. Por favor, inténtelo de nuevo más adelante',
                'KPIS': {
                    'TITULOBORRAR': 'Borrar KPI',
                    'MENSAJEBORRAR': '¿Está seguro de borrar el KPI seleccionado?',
                    'KPIBORRADO': 'El kpi ha sido eliminado correctamente',
                    'KPINOBORRADO': 'No hemos podido eliminar el kpi. Por favor, inténtelo de nuevo más adelante'
                },
                'SECTORES': {
                    'NOOBTENIDOS': 'No hemos podido recuperar datos de los sectores'
                },
                'SOCIEDADES': {
                    'NOOBTENIDOS': 'No hemos podido recuperar datos de las sociedades propietarias'
                },
                'TIPOLOGIAS': {
                    'NOOBTENIDAS': 'No hemos podido recuperar datos de los tipologías disponibles'
                },
                'ESTADOSPROYECTO': {
                    'NOOBTENIDOS': 'No hemos podido recuperar datos de los estados del proyecto disponibles'
                },
                'CLIENTES': {
                    'NOOBTENIDOS': 'No hemos podido obtener datos de ningún cliente al que asignar el activo'
                },
                'POWERBI': {
                    'TITULOBORRAR': 'Borrar PowerBI',
                    'MENSAJEBORRAR': '¿Está seguro de borrar el PowerBI seleccionado?',
                    'BORRADO': 'El PowerBI ha sido eliminado correctamente',
                    'NOBORRADO': 'No hemos podido eliminar el PowerBI. Por favor, inténtelo de nuevo más adelante',
                    'NOENCONTRADO': 'No se ha encontrado el reporte de PowerBI. Por favor, asegúrese de que el identificador es correcto'
                },
                '3DVIEWER': {
                    'NOENLACE': 'No existe enlace asociado para este activo'
                },
                'MODELBUILT': {
                    'NOENLACE': 'No existe enlace built asociado para este activo'
                },
                'CARGAEXCEL': {
                    'OKSUBIDO': 'Los activos se han subido correctamente',
                    'ERRORSUBIDA': 'No hemos podido subir los activos. Por favor, inténtelo de nuevo más adelante'
                }
            }
        },
        'SOCIEDADES': {
            'TABLA': {
                'NOMBRE': 'Nombre',
            },
            'LISTADO': {
                'TITULO': 'Gestión de Sociedades',
                'ADDSOCIEDAD': 'Añadir Sociedad',
            },
            'DETALLE': {
                'TITULO': 'Detalle de Sociedad',
                'NOMBRE': 'Nombre',
            },
            'EDITAR': {
                'EDITAR_TITULO': 'Editar Sociedad',
                'CREAR_TITULO': 'Edit Sociedad',
                'NOMBRE': 'Nombre',
                'GUARDAR': 'Guardar',
                'CANCELAR': 'Cancelar'
            },
            'MENSAJES': {
                'TITULOBORRAR': 'Borrar Sociedad',
                'MENSAJEBORRAR': '¿Está seguro de borrar la sociedad seleccionada?',
                'SINSOCIEDADES': 'No hemos obtenido datos de ninguna sociedad',
                'SOCIEDADBORRADO': 'La sociedad ha sido eliminada correctamente',
                'SOCIEDADNOBORRADO': 'No hemos podido eliminar la sociedad. Por favor, inténtelo de nuevo más adelante',
                'SOCIEDADNOOBTENIDO': 'No hemos podido obtener la sociedad. Por favor, inténtelo de nuevo más adelante',
                'SOCIEDADCREADO': 'La sociedad ha sido creado correctamente',
                'SOCIEDADNOCREADO': 'No hemos podido crear la sociedad. Por favor, inténtelo de nuevo más adelante',
                'SOCIEDADEDITADO': 'La sociedad ha sido editado correctamente',
                'SOCIEDADNOEDITADO': 'No hemos podido editar la sociedad. Por favor, inténtelo de nuevo más adelante',
            }
        },
        'TICKETS': {
            'TABLA': {
                'TITULO': 'Título',
                'PRIORIDAD': 'Prioridad',
                'SOLICITANTE': 'Solicitante',
                'ESTADO': 'Estado',
                'ASIGNADO': 'Asignado',
                'ACTIVO': 'Activo',
                'ASOCIADO': 'Documento asociado',
                'DOCUMENTO': 'Descargar documento asociado',
                'FECHA': 'Fecha de creación'
            },
            'LISTADO': {
                'TITULO': 'Gestión de Tickets',
                'AGREGAR': 'Añadir ticket'
            },
            'DETALLE': {
                'TITULO': 'Detalle de Ticket',
                'TITULOTICKET': 'Ticket',
                'ESTADO': {
                    'NOMBRE': 'Estado',
                    'ABIERTA': 'Abierta',
                    'PROCESANDO': 'En proceso',
                    'CERRADA': 'Cerrada'
                },
                'SOLICITANTE': 'Solicitante',
                'ACTIVO': 'Activo',
                'DESCRIPCION': 'Descripción',
                'PRIORIDAD': {
                    'NOMBRE': 'Prioridad',
                    'ALTA': 'Alta',
                    'MEDIA': 'Media',
                    'BAJA': 'Baja'
                },
                'ASIGNADO': 'Asignado',
                'OBSERVACIONES': 'Observaciones'
            },
            'EDITAR': {
                'EDITAR_TITULO': 'Editar Ticket',
                'CREAR_TITULO': 'Nuevo Ticket',
                'TITULOTICKET': 'Título',
                'ESTADO': {
                    'NOMBRE': 'Estado',
                    'ABIERTA': 'Abierta',
                    'PROCESANDO': 'En proceso',
                    'CERRADA': 'Cerrada'
                },
                'SOLICITANTE': 'Solicitante',
                'ACTIVO': 'Activo',
                'DESCRIPCION': 'Descripción',
                'PRIORIDAD': {
                    'NOMBRE': 'Prioridad',
                    'ALTA': 'Alta',
                    'MEDIA': 'Media',
                    'BAJA': 'Baja'
                },
                'ASIGNADO': 'Asignado',
                'OBSERVACIONES': 'Observaciones',
                'GUARDAR': 'GUARDAR',
                'CANCELAR': 'CANCELAR',
                'ADD-ANEXO': 'Añadir anexo',
                'AVISOANEXO': 'Para añadir adjuntos, primero debes crear el ticket'
            },
            'MENSAJES': {
                'TITULOBORRAR': 'Borrar Ticket',
                'MENSAJEBORRAR': '¿Está seguro de borrar el ticket seleccionado?',
                'SINTICKETSDEACTIVO': 'No hemos obtenido hay referencias de ningún ticket sobre este activo',
                'SINTICKETS': 'No hemos obtenido datos de ningún ticket',
                'TICKETBORRADO': 'El ticket ha sido eliminado correctamente',
                'TICKETNOBORRADO': 'No hemos podido eliminar el ticket. Por favor, inténtelo de nuevo más adelante',
                'TICKETNOOBTENIDO': 'No hemos podido obtener el ticket. Por favor, inténtelo de nuevo más adelante',
                'TICKETCREADO': 'El ticket ha sido creado correctamente',
                'TICKETNOCREADO': 'No hemos podido crear el ticket. Por favor, inténtelo de nuevo más adelante',
                'TICKETEDITADO': 'El ticket ha sido editado correctamente',
                'TICKETNOEDITADO': 'No hemos podido editar el ticket. Por favor, inténtelo de nuevo más adelante',
                'SINDOCUMENTO': 'El ticket no tiene asociado ningún documento',
                'ELEGIRDOCUMENTO': '¡Atención! Debes seleccionar primero el documento sobre el que generar el ticket',
                'USUARIOS': {
                    'SINUSUARIOS': 'No hemos podido recuperar datos de ningún usuario. Si quiere asignar el ticket a alguien, inténtelo de nuevo más adelante'
                },
                'ACTIVOS': {
                    'SINACTIVOS': 'No hemos podido recuperar datos de ningún activo. Si quiere asignar el ticket a alguno, inténtelo de nuevo más adelante'
                },
                'NOPUEDEVERANEXO': 'Debe crear el ticket antes de poder incorporar documentos adjuntos',
                'ANEXOADDED': 'Anexo añadido'
            },
            'ANEXOS': 'Anexos'
        },
        'CLIENTES': {
            'LISTADO': {
                'TITULO': 'Gestión de Clientes'
            },
            'DETALLE': {
                'TITULO': 'Detalle de Cliente'
            },
            'EDITAR': {
                'EDITAR_TITULO': 'Editar Cliente',
                'CREAR_TITULO': 'Nuevo Cliente',
                'GUARDAR': 'GUARDAR',
                'CANCELAR': 'CANCELAR',
                'EDITARLOGO' : 'EDITAR LOGO',
                'ADDCLIENTE': 'Añadir Cliente'
            },
            'MENSAJES': {
                'TITULOBORRAR': 'Borrar Cliente',
                'MENSAJEBORRAR': '¿Está seguro de borrar el cliente seleccionado?',
                'SINCLIENTES': 'No hemos obtenido datos de ningún cliente',
                'CLIENTEBORRADO': 'El cliente ha sido eliminado correctamente',
                'CLIENTENOBORRADO': 'No hemos podido eliminar el cliente. Por favor, inténtelo de nuevo más adelante',
                'CLIENTENOOBTENIDO': 'No hemos podido obtener el cliente. Por favor, inténtelo de nuevo más adelante',
                'CLIENTECREADO': 'El cliente ha sido creado correctamente',
                'CLIENTENOCREADO': 'No hemos podido crear el cliente. Por favor, inténtelo de nuevo más adelante',
                'CLIENTEEDITADO': 'El cliente ha sido editado correctamente',
                'CLIENTENOEDITADO': 'No hemos podido editar el cliente. Por favor, inténtelo de nuevo más adelante'
            },
            'CAMPOS': {
                'NOMBRE': 'Nombre',
                'CODIGO': 'Código',
                'USUARIOAWS': 'Usuario AWS',
                'PASSAWS': 'Contraseña AWS',
                'BUCKETAWS': 'Bucket AWS',
                'USUARIOSCREADOS': 'Usuarios creados',
                'MAXUSUARIOS': 'Máx. usuarios',
                'ACTIVOS': 'Activos',
                'MAXACTIVOS': 'Máx. activos',
                'POWERBIDASHBOARD': 'General Dashboard PowerBI ID',
                'HIDEFILTERS': 'Ocultar filtros específicos',
            }
        },
        'USUARIOS': {
            'LISTADO': {
                'TITULO': 'Gestión de Usuarios',
                'NOMBRE': 'Nombre',
                'APELLIDOS': 'Apellidos',
                'CLIENTE': 'Cliente',
                'ACCIONES': 'Acciones',
                'ROL': 'Rol',
                'USUARIOSRESTANTES': 'Usuarios restantes del cliente',
                'ADDUSUARIO': 'Añadir Usuario',
                'HIDDENASSETS': 'Activos ocultos'
            },
            'DETALLE': {
                'TITULO': 'Detalle de Usuario'
            },
            'EDITAR': {
                'EDITAR_TITULO': 'Editar Usuario',
                'CREAR_TITULO': 'Nuevo Usuario',
                'GUARDAR': 'GUARDAR',
                'CANCELAR': 'CANCELAR',
            },
            'MENSAJES': {
                'TITULOBORRAR': 'Borrar Usuario',
                'MENSAJEBORRAR': '¿Está seguro de borrar el usuario seleccionado?',
                'SINUSUARIOS': 'No hemos obtenido datos de ningún usuario',
                'USUARIOBORRADO': 'El usuario ha sido eliminado correctamente',
                'USUARIONOBORRADO': 'No hemos podido eliminar el usuario. Por favor, inténtelo de nuevo más adelante',
                'USUARIONOOBTENIDO': 'No hemos podido obtener el usuario. Por favor, inténtelo de nuevo más adelante',
                'USUARIOCREADO': 'El usuario ha sido creado correctamente',
                'USUARIONOCREADO': 'No hemos podido crear el usuario. Por favor, inténtelo de nuevo más adelante',
                'USUARIOEDITADO': 'El usuario ha sido editado correctamente',
                'USUARIONOEDITADO': 'No hemos podido editar el usuario. Por favor, inténtelo de nuevo más adelante',
                'ROLES': {
                    'SINROLES': 'Se ha producido un error y no hemos podido obtener los roles. Por favor, inténtelo de nuevo más adelante'
                },
                'CLIENTES': {
                    'NOOBTENIDOS': 'No hemos podido obtener datos de ningún cliente al que asignar el usuario'
                },
                'ACTIVOSOCULTOS': {
                    'SINACTIVOS': 'Se ha producido un error y no hemos podido obtener los activos ocultos. Por favor, inténtelo de nuevo más adelante'
                },
            }
        },
        'FILEMANAGER': {
            'LISTADO': {
                'TITULO': 'Gestor documental',
                'CLIENTE': 'Escoge un cliente',
                'BUSCAR': 'Buscar Archivo',
                'CARPETA': 'Nueva Carpeta',
                'SUBIR': 'Subir Archivo',
                'NOMBRE': 'Nombre',
                'VERSION': 'Versión',
                'SIZE': 'Tamaño',
                'MODIFICACION': 'Última modificación',
                'SUBIR_VERSION': 'Nueva versión',
                'TICKET': 'Generar ticket sobre este documento',
                'QR': 'Imprimir Pdf con QR',
                'PREVIEW': 'Visualizar',
                'GEN-TICKET': 'Generar ticket',
                'COPY': 'Copiar',
                'ASOCIADO': 'Activo Asociado',
                'PRINT-QR': 'Imprimir con QR',
                'ROOT_FOLDER': 'Carpeta Proyecto',
                'ASOCIAR_TICKET': 'Asociar a Ticket',
                'ASOCIAR_ACTIVO': 'Asociar a Activo'
            },
            'CLIENTENOESTABLECIDO': '¡Atención! Debe establecer el cliente del cuál consultar la documentación',
            'SINRESULTADOS': 'Su búsqueda no ha producido ningún resultado',
            'NOMBREINCORRECTO': 'El nombre no puede contener el caracter "/"',
            'INICIOCOPIA': 'Archivo insertado en el portapapeles. Desplácese a la ubicación que desee y pulse en el botón "COPIAR AQUÍ" para copiarlo',
            'COPIAR': 'COPIAR AQUÍ',
            'COPIAENRAIZNOPERMITIDA': 'No se puede copiar el fichero en el nivel raíz',
            'COPIAENMISMACARPETA': 'No se puede copiar el fichero en la carpeta de origen',
            'BORRARCARPETA': {
                'TITULO': '¡Atención!',
                'MENSAJE': '¿Está seguro de borrar la carpeta y todo su contenido?'
            },
            'BORRARARCHIVO': {
                'TITULO': 'Borrar Archivo',
                'MENSAJE': '¿Está seguro de borrar el archivo seleccionado?'
            },
            'ACTIVO': {
                'ASOCIADO': 'Activo asociado'
            },
            'ACTIVOCARPETANOTFOUND': 'No se ha podido obtener el activo al que pertenece la carpeta actual',
            'SUBIDAVERSION': 'La versión se ha subido correctamente',
            'SUBIRARCHIVOEXISTENTE': {
                'TITULO': '¡Atención!',
                'MENSAJE': 'El archivo ya existe. ¿Subir nueva versión?'
            },
        },
        'GENERAL-DASHBOARD': {
            'TITULO': 'Dashboard PowerBI General'
        },
        'POWER-BI': {
            'TITULO': 'Power BI'
        },
        '3D-VIEWER': {
            'TITULO': '3D Viewer'
        },
        'MYPROFILE': {
            'TITULO' : 'Mi Perfil',
            'CAMBIARPASS': 'Cambiar contraseña',
            'PASS1': 'Contraseña nueva',
            'PASS2': 'Repita constraseña ',
            'MENSAJES': {
                'PASSACTUALIZADA': 'La contraseña ha sido actualizada correctamente',
                'PASSIGUAL': 'La contraseña coincide con la anterior',
                'PASSRESETEADA': 'Le hemos enviado un email con su nueva contraseña',
                'PASSNORESETEADA': 'La contraseña no se ha podido resetear, vuelva intentarlo más tarde',
                'FORMULARIOENVIADO': 'Su mensaje ha sido enviado',
                'FORMULARIONOENVIADO': 'Su mensaje no se ha podido enviar, vuelva intentarlo más tarde',
            },
            'ACTUALIZAR': 'Actualizar Datos',
        },
        'ACCIONES': 'Acciones',
        'BUSCAR': 'Buscar...',
        'ITEMSXPAGINA': 'Resultados por página',
        'SESIONEXPIRADA': 'Sesión expirada',
        'NOAUTORIZADO': 'No autorizado',
        'ERRORCONEXION': 'Error de conexión. Por favor, inténtelo de nuevo más adelante',
        'ERRORDESCONOCIDO': 'Se ha producido un error desconocido. Por favor, inténtelo de nuevo más adelante',
        'LOGIN': {
            'CREDENCIALESINVALIDAS': 'Usuario o contraseña no válidos',
            'USUARIO': 'Usuario',
            'PASS': 'Contraseña',
            'RECORDAR': 'Recordarme',
            'OLVIDADA': '¿Contraseña Olvidada?',
            'ACCEDER': 'ACCEDER'
        },
        'TIPOFOTO': 'Debe subir una fotografía de tipo JPG o PNG',
        'TIPOEXCEL': 'Debe subir un archivo EXCEL',
        'ACEPTAR': 'Aceptar',
        'CANCELAR': 'Cancelar',
        'DESCARGAR': 'Descargar',
        'BORRAR': 'Eliminar',
        'DETALLE' : 'Detalle',
        'EDITAR': 'Editar',
        'LISTA_TICKETS': 'Listado de tickets',
        'SELECCIONAR': 'Seleccionar',
        'VER-EDITAR': 'Ver / Editar',
        'ENVIAR': 'Enviar',
        'TOOLBAR': {
            'CONTACTO': {
                'TITULO': 'Formulario de contacto',
                'PROBLEMA': 'Problema',
                'DESCRIPCION': 'Descripción'
            }
        },
        'MAPA': {
            'POPUP': {
                'TIPOLOGIA': 'Tipología',
                'LOCALIZACION': 'Localización',
            }
        },
        'FORGOT': {
            'RECUPERAR': 'RECUPERAR CONTRASEÑA',
            'RESET': 'RESETEAR CONTRASEÑA',
            'VOLVER': 'Volver al login'

        }
    }
};



// WEBPACK FOOTER //
// ./src/app/i18n/es.ts